import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDisponibilidadConsolidadaEspecialPichincha } from '../hooks/useDisponibilidadConsolidadaEspecialPichincha';
import { useFiltrosDashboardPichincha } from '../../../store/useFiltersDashboardPichincha';
import { SolidGauge } from './SolidGauge';
import { Alert } from '@material-ui/lab';
import { useDisponibilidadConsolidada } from '../../../hooks/useDisponibilidadConsolidada';

export function GaugeGraphs() {
  const { t } = useTranslation();
  const globalStatePeriod = useFiltrosDashboardPichincha(
    (state) => state.globalStatePeriod,
  );

  const objetivo = useFiltrosDashboardPichincha((state) => state.objetivo);
  const { data, isLoading, isError } = useDisponibilidadConsolidada({
    objetivoId: objetivo?.objetivo_id.toString() ?? null,
    fechaInicio: globalStatePeriod.startDate,
    fechaTermino: globalStatePeriod.endDate,
  });
  const {
    data: dataConsolidadoPichincha,
    isLoading: isLoadingConsolidadoPichincha,
    isError: isErrorConsolidadoPichincha,
  } = useDisponibilidadConsolidadaEspecialPichincha({
    objetivoId: objetivo?.objetivo_id.toString() ?? null,
    fechaInicio: globalStatePeriod.startDate,
    fechaTermino: globalStatePeriod.endDate,
  });

  if (!objetivo) {
    return null;
  }

  return (
    <Grid container spacing={2}>
      {!isLoading && isError && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Alert severity="error">
            {t('sync.availability.chart.error.loadDisp')}
          </Alert>
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SolidGauge
          isLoading={isLoading}
          title={t('sync.availability.sync.label.normalDisp')}
          indicador={
            parseFloat(
              (
                (data?.data?.evento_cliente ?? 0) +
                (data?.data?.marcado_atentus ?? 0) +
                (data?.data?.parcial ?? 0) +
                (data?.data?.uptime ?? 0) +
                (data?.data?.['no monitoreo'] ?? 0)
              ).toFixed(2),
            ) ?? 0
          }
          color="#66d483"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SolidGauge
          isLoading={isLoading}
          title={t('sync.availability.chart.label.downtime')}
          indicador={data?.data?.downtime ?? 0}
          color="#f2786f"
        />
      </Grid>
      {!isLoadingConsolidadoPichincha && isErrorConsolidadoPichincha && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Alert severity="error">
            {t('sync.availability.chart.error.loadDisp')}
          </Alert>
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SolidGauge
          isLoading={isLoadingConsolidadoPichincha}
          title={t('sync.availability.sync.label.pichinchaDisp')}
          indicador={parseFloat(
            (
              (dataConsolidadoPichincha?.data?.uptime ?? 0) +
              (dataConsolidadoPichincha?.data?.evento_cliente ?? 0) +
              (dataConsolidadoPichincha?.data?.marcado_atentus ?? 0) +
              (dataConsolidadoPichincha?.data?.no_monitoreo ?? 0)
            ).toFixed(2),
          )}
          color="#66d483"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SolidGauge
          isLoading={isLoadingConsolidadoPichincha}
          title={t('sync.availability.sync.label.pichinchaDowntime')}
          indicador={parseFloat(
            (dataConsolidadoPichincha?.data?.downtime ?? 0).toFixed(2),
          )}
          color="#f2786f"
        />
      </Grid>
    </Grid>
  );
}
